import React, { useState, useEffect } from "react";
import { Modal } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { selectAuthState, setCloseAuthModal, setIsPendingRegister } from "@/stores/slices/authSlice";
import LoginComponent from "./Login";
import RegisterComponent from "./Register";
import ResetPassword from "./ResetPassword";
import { IconCloseSvg } from "@/components/svgs";
import { noop } from "lodash";

const AuthModal = ({ onFinish = noop }) => {
	const dispatch = useDispatch();
	const { openAuthModal, openAuthTitle, openAuthMode } = useSelector(selectAuthState);
	const [type, setType] = useState("LOGIN"); // LOGIN / REGISTER / RESET

	useEffect(() => {
		if (openAuthMode && openAuthMode !== type) {
			setType(openAuthMode);
		}
	}, [openAuthMode]);

	const onCloseAuthModal = () => {
		dispatch(setCloseAuthModal());
	};

	const onCancel = () => {
		setType("LOGIN");
		onCloseAuthModal();
		dispatch(setIsPendingRegister({ value: false }));
	};

	const changeRoute = (route) => {
		if (route) setType(route);
		if (route === "REGISTER") {
			dispatch(setIsPendingRegister({ value: true }));
		}
	};

	const goBack = () => {
		setType("LOGIN");
		dispatch(setIsPendingRegister({ value: false }));
	};

	const onRegisterSuccess = async () => {
		setType("LOGIN");
		dispatch(setIsPendingRegister({ value: false }));
		onCloseAuthModal();
	};

	const _renderContentAuth = () => {
		switch (type) {
			case "LOGIN":
				return <LoginComponent onFinish={onFinish} changeRoute={changeRoute} openAuthTitle={openAuthTitle} />;
			case "REGISTER":
				return <RegisterComponent onFinish={onFinish} goBack={goBack} onRegisterSuccess={onRegisterSuccess} />;
			case "RESET":
				return <ResetPassword changeRoute={changeRoute} goBack={goBack} />;
			default:
				return <LoginComponent onFinish={onFinish} changeRoute={changeRoute} openAuthTitle={openAuthTitle} />;
		}
	};

	return openAuthModal ? (
		<Modal
			centered
			open={openAuthModal}
			closeIcon={<IconCloseSvg />}
			onOk={() => {}}
			onCancel={() => onCancel(false)}
			footer={null}
			width="auto"
			wrapClassName="auth-wrapper"
			style={{ padding: 0, margin: "20px 0px" }}
			maskClosable={false}
			data-testid="AuthModal_container"
		>
			{_renderContentAuth()}
		</Modal>
	) : null;
};

export default AuthModal;
